module.exports = __webpack_public_path__ + "static/media/precoL2L.378278b4.svg";